import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, WrenchIcon, TruckIcon } from 'lucide-react';
const requirements = [{
  icon: BriefcaseIcon,
  title: 'Amplia experiencia comprobable',
  description: 'Buscamos profesionales con trayectoria demostrable en instalaciones de gas LP'
}, {
  icon: WrenchIcon,
  title: 'Herramientas propias',
  description: 'Debe contar con equipo y herramientas necesarias para realizar instalaciones profesionales'
}, {
  icon: TruckIcon,
  title: 'Vehículo propio',
  description: 'Transporte propio para movilizarse a diferentes localidades de su área'
}];
export function Requirements() {
  return <section className="w-full bg-white py-20 px-4" id="requisitos" data-id="element-31">
      <div className="max-w-6xl mx-auto" data-id="element-32">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-jazugas-black text-center mb-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-33">
          Requisitos
        </motion.h2>
        <motion.p className="text-lg text-gray-600 text-center mb-16 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-34">
          Para formar parte de nuestro equipo de instaladores profesionales
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-35">
          {requirements.map((req, index) => {
          const Icon = req.icon;
          return <motion.div key={index} className="bg-gray-50 rounded-2xl p-8 border-2 border-transparent hover:border-jazugas-blue transition-all duration-300" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-36">
                <div className="flex flex-col items-center text-center" data-id="element-37">
                  <div className="w-16 h-16 bg-jazugas-blue rounded-xl flex items-center justify-center mb-6" data-id="element-38">
                    <Icon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-39" />
                  </div>
                  <h3 className="text-xl font-bold text-jazugas-black mb-3" data-id="element-40">
                    {req.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-41">
                    {req.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}